import { computed, watch } from 'vue'

const TOMOGRAPHY_FIELDS = [
  'tilting_method',
  'series_size',
  'angle_step',
  'tilt_range',
]

/**
 * Conditional visibility for the Tomography section in Transmission EM assays.
 * Shows the section only when tem_type is "Tomography" and resets its fields
 * when the section is hidden.
 *
 * @param {Object} dv - The reactive detail view object
 */
export function useTomographyToggle(dv) {
  const showTomography = computed(
    () => dv.editedRecord['tem_type']?.value?.label === 'Tomography',
  )

  watch(showTomography, (show) => {
    if (!show) {
      TOMOGRAPHY_FIELDS.forEach((name) => dv.resetField({ name }))
    }
  })

  return { showTomography }
}
